<div class="d__flex just-e">
  <ion-title *ngIf="!db.ismobile && false" class="ion-title">Address</ion-title>
  <ion-button class="add__button" color="" fill="clear" (click)="add_address()">
    <ion-icon src="assets/icons/add-voilet.svg"></ion-icon>Add
  </ion-button>
</div>
<div [ngClass]="!is_modal?'address__lists_w':'address__lists_w_m'" class="address__lists">
  <ion-list class="address__mouse mouse animated fadeInUp" *ngFor="let item of db.address_list;let i=index" (click)="selected_address = item">
    <div [ngClass]="!is_modal?'address__list_w':'address__list_w_m'" (click)="select_customer(address,i)" class="address__list" *ngFor="let address of item.address">
      <!-- <div (click)="select_customer(address,i)"> -->
        <h5 class="name-title">{{address.first_name}} {{address.last_name}}</h5>
        <p class="address">
          {{address.address }} {{address.city}} - {{address.zipcode}}<br>
          {{address.state}} {{address.country}} &ensp;&ensp;&ensp;<span *ngIf="address.phone">Contact: {{address.phone}}</span></p>
        <div class="action__buttons">
          <div class="d__flex">
            <ion-button class="edit__button ion-text-capitalize" fill="clear" color="success" size="small" (click)="edit_address(address,i)">
              <ion-icon color="success" src="assets/icons/edit.svg"></ion-icon>
            </ion-button>
            <span> | </span>
            <ion-button class="delete__button ion-text-capitalize" fill="clear" color="danger" size="small" (click)="confirm_delete(address,i)">
              <ion-icon color="danger" src="assets/icons/delete.svg"></ion-icon>
            </ion-button>
          </div>
        </div>
      <!-- </div> -->
    </div>
  </ion-list>
</div>
<div [ngClass]="is_modal?'modal_address__img':'address__img'" *ngIf="db.address_list && db.address_list.length && db.address_list[0].address.length == 0">
    <img src="assets/icons/wallet-null.svg" alt="">
    <p>Sorry, your Address is empty..!</p>
  </div>
